

import Vue from "vue"
import App from "@/App"
import router from "./router"
import store from "./store"

import MZUI from 'mengzhua-ui'
import 'mengzhua-ui/components/theme-default/lib/index.css'
/* eslint-disable no-unused-vars */

import VueResource from "vue-resource"
import './lib/httpConfig'
import Datetime from 'vux/src/components/datetime/index.vue'

import { getQueryString } from "./common/js/util"
import BrowserLogger from "alife-logger"
import filters from "./common/js/filter"
import { Radio, RadioGroup, Swipe, SwipeItem, Lazyload } from 'vant'
import 'vant/lib/index.css'

Vue.use(MZUI)
import('./lib/style/common/common.scss')
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))


Vue.use(VueResource)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.component("datetime", Datetime)
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(Lazyload);

let now = Date.parse(new Date()),
activityEndTime = new Date('2020/11/15 23:59').getTime()
if (activityEndTime - now > 0) {
store.state.noActivity = false
} else {
store.state.noActivity = true
}


var way = window.location.origin
if (way.indexOf("wecarepet") > -1) {
store.state.origin = ""
store.state.routerPath = "/web"
} else {
store.state.origin = "/apis"
store.state.routerPath = ""
var cookieList =
"randomNum=1627591697; _bl_uid=8vk19r2zotdbeyfULhvyxU2r40R4; _ga=GA1.2.731924990.1637128277; mp_58e8f72ac9adddbae73aa52147db7550_mixpanel=%7B%22distinct_id%22%3A%20%2217d2c77278b52d-0862c5c7649c37-1c306851-1ea000-17d2c77278caef%22%2C%22%24device_id%22%3A%20%2217d2c77278b52d-0862c5c7649c37-1c306851-1ea000-17d2c77278caef%22%2C%22%24initial_referrer%22%3A%20%22%24direct%22%2C%22%24initial_referring_domain%22%3A%20%22%24direct%22%7D; Hm_lvt_f89755c8f98b5f43890db9112039364f=1636538125,1637128276,1637312432; Hm_lpvt_f89755c8f98b5f43890db9112039364f=1637733166; _hp2_id.2914011488=%7B%22userId%22%3A%227576080703490620%22%2C%22pageviewId%22%3A%227533738041532007%22%2C%22sessionId%22%3A%223693974975065219%22%2C%22identity%22%3Anull%2C%22trackerVersion%22%3A%224.0%22%7D; Hm_lvt_06a6011c55f9e05ee42ba1386e077d08=1637733171; pia_sso_refresh_token=3e9ea14a-721a-4322-bce7-100451a67e73; pia_sso_token=7dc4a76d-93b5-4f1f-bf02-287be1039a0e; SID=e92dd42a-7303-4d1c-9337-2cf65eb316f9; Hm_lpvt_06a6011c55f9e05ee42ba1386e077d08=1637822871"
for (var i = 0; i < cookieList.split(";").length; i++) {
document.cookie = cookieList.split(";")[i]
}
}

if (way.indexOf("www.wecarepet") > -1) {
let newWay = way.replace("www.wecarepet", "m.wecarepet")
location.href = newWay
}

function compare(a, b) {
if (a === b) {
return true
}
var a_components = a.split(".")
var b_components = b.split(".")
var len = Math.min(a_components.length, b_components.length)
for (var i = 0; i < len; i++) {
if (parseInt(a_components[i]) > parseInt(b_components[i])) {
return true
}

if (parseInt(a_components[i]) < parseInt(b_components[i])) {
return false
}
}
if (a_components.length > b_components.length) {
return true
}
if (a_components.length < b_components.length) {
return false
}
return true
}
store.state.isMobile = navigator.userAgent.indexOf('MengZhua') > -1 ? true : false
store.state.version = store.state.isMobile ? navigator.userAgent.split('MengZhua/Android/')[1].split('/')[0] : null
console.log('version', store.state.version)
store.state.canJumpMinni = store.state.version ? compare(`${store.state.version}`, "1.0.3") : false
console.log('canJumpMinni', store.state.canJumpMinni)


function toLogin(to) {

GLOBAL.init()
console.log('inWeixin', GLOBAL.inWeixin)
let targetUrl = location.origin + "/web" + to.fullPath
if (GLOBAL.inWeixin) {
LOGIN.loginWeixin(targetUrl)
} else {
router.push({
path: "/normalLogin",
query: {
redirect: targetUrl
}
})
}
}
store.dispatch('getLoginStatus')


router.beforeEach((to, from, next) => {
let source = getQueryString("source")
if (source) {
GLOBAL.setCookie("LoginSource", source, 1)
}
if (to.meta.title) {
document.title = to.meta.title
}
let profile = getQueryString("profile") ? getQueryString("profile") : GLOBAL.getCookie("profile")
store.state.profile = profile
if (profile) {





}
if (to.matched.some(record => record.meta.requireLogin)) {  // 判断该路由是否需要登录权限
let LoginStatus = GLOBAL.getInfo('LoginStatus')
console.log('LoginStatus', LoginStatus)
if (typeof (LoginStatus) == undefined) {
store.dispatch('getLoginStatus')
} else if (LoginStatus == 'false') {
toLogin(to)
} else {
if (!store.state.ownerView || !store.state.userProfile) {
store.dispatch('getLoginStatus').then((res) => {
store.dispatch("getProfile").then(res => {
next()
})
}).catch((err) => {
console.log('2', err)
toLogin(to)
})
} else {
next()
}
}
} else {
next()
}
})

/* eslint-disable no-new */
new Vue({
el: "#app",
router,
store,
components: { App },
template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js